import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getTimeslots({ commit }) {
    commit(types.GET_TIMESLOTS_REQUEST);

    colonyAPI
      .get('timeslots/')
      .then(response => commit(types.GET_TIMESLOT_SUCCESS, response))
      .catch(error => commit(types.GET_TIMESLOT_FAILURE, error));
  },

  createTimeslot({ commit, dispatch }, payload) {
    commit(types.SAVE_TIMESLOT_REQUEST);

    colonyAPI
      .post('timeslots/', payload)
      .then(response => {
        dispatch('getTimeslots');
        return response;
      })
      .then(response => commit(types.SAVE_TIMESLOT_SUCCESS, response))
      .catch(error => commit(types.SAVE_TIMESLOT_FAILURE, error));
  },

  updateTimeslot({ commit, dispatch }, payload) {
    commit(types.SAVE_TIMESLOT_REQUEST);

    colonyAPI
      .put(`timeslots/${payload.id}/`, payload)
      .then(response => {
        dispatch('getTimeslots');
        return response;
      })
      .then(response => commit(types.SAVE_TIMESLOT_SUCCESS, response))
      .catch(error => commit(types.SAVE_TIMESLOT_FAILURE, error));
  },

  deleteTimeslot({ commit, dispatch }, id) {
    commit(types.DELETE_TIMESLOT_REQUEST);

    colonyAPI
      .delete(`timeslots/${id}/`)
      .then(response => {
        dispatch('getTimeslots');
        return response;
      })
      .then(() => commit(types.DELETE_TIMESLOT_SUCCESS))
      .catch(error => commit(types.DELETE_TIMESLOT_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeslots/actions.js